import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('api', 'tipo-beneficio');

const tipoBeneficioActions = {
  listarAtivos: { method: 'GET', url: `${basePath}/ativos` },
};

export default (resource) => resource(`${basePath}`, {}, tipoBeneficioActions);
